import React from 'react'
import PropTypes from 'prop-types'
import styles from 'src/components/Modal/Modal.module.sass'
import cx from 'classnames'

const Modal = ({
  children,
  className = '',
  containerClassName = '',
  onClick = () => {}
}) => {
  return (
    <div className={cx(styles.modal, containerClassName)}>
      <button
        type="button"
        className={cx(styles.modalContent, className)}
        onClick={onClick}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClick(e)
          }
        }}
      >
        {children}
      </button>
    </div>
  )
}

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  onClick: PropTypes.func
}

export default Modal
